var React = require('react');

function Messenger (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"263FAB44-5639-4EF1-86F0-04F263271522"),React.createElement("desc",{"key":1},"Created with sketchtool."),React.createElement("defs",{"key":2}),React.createElement("g",{"id":"MOBILE","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":3},React.createElement("g",{"id":"1.7.9-Activities-Added-Share-Example","transform":"translate(-175.000000, -333.000000)","fill":"#007FFF"},React.createElement("g",{"id":"Social","transform":"translate(159.000000, 165.000000)"},React.createElement("path",{"d":"M25,168 C20.0294286,168 16,171.730944 16,176.333333 C16,178.955833 17.3087453,181.295056 19.3540373,182.822611 L19.3540373,186 L22.4184534,184.318167 C23.2362795,184.5445 24.1026832,184.666667 25,184.666667 C29.9705714,184.666667 34,180.935722 34,176.333333 C34,171.730944 29.9705714,168 25,168 L25,168 Z M25.8944099,179.222222 L23.6024845,176.777778 L19.1304348,179.222222 L24.0496894,174 L26.3975155,176.444444 L30.8136646,174 L25.8944099,179.222222 L25.8944099,179.222222 Z","id":"Messenger"}))))]);
}

Messenger.defaultProps = {"width":"18px","height":"18px","viewBox":"0 0 18 18","version":"1.1"};

module.exports = Messenger;

Messenger.default = Messenger;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/common/svg/icons/messenger.svg
// module id = 1500
// module chunks = 0